import React, { useEffect, useState } from "react";
import { Box, Button, HStack, VStack } from "native-base";
import { useDutchieStore } from "@springbig/shared";
import { useGeneralStyles } from "~/shared/styles";
import { Caption } from "~/shared/Typography";
import { FilterView } from "./FilterView";

interface FilterDrawerProps {
	isDrawerOpen: boolean;
    setIsDrawerOpen: (value: boolean) => void;
}

export default function FilterDrawer({ isDrawerOpen, setIsDrawerOpen }: FilterDrawerProps) {const { filters, setFilters } = useDutchieStore();
    const gStyle = useGeneralStyles();
    const {
        cartItemsAmount,
    } = useDutchieStore();

    const [TOP_NAV_BAR, setTOP_NAV_BAR] = useState(157);

    useEffect(() => {
        
        if (cartItemsAmount) {
            setTOP_NAV_BAR(240);
        }
    }, [cartItemsAmount]);

    return (
        <Box
            flex={1}
            backgroundColor={gStyle.screen_background}
            justifyContent={"center"}
            alignItems={"center"}
            zIndex={9999}
        >
            <VStack
                position="absolute"
                top={0}
                right={0}
                width={"60%"}
                backgroundColor={gStyle.screen_background}
                zIndex={2}
                padding={4}
                space={4}
                height={window.innerHeight - TOP_NAV_BAR}
            >
                <VStack>
                    <HStack alignItems={"center"} justifyContent={"space-between"}>
                        <Caption fontSize={18}>filters</Caption>
                        <Button onPress={() => setIsDrawerOpen(false)}>
                            <Caption fontSize={18}>X</Caption>
                        </Button>
                    </HStack>
                </VStack>
                <FilterView
                    filters={filters}
                    setFilters={setFilters}
                    setShowFilters={() => {
                        setIsDrawerOpen(!isDrawerOpen);
                    }}
                />
            </VStack>

            {isDrawerOpen && (
                <Button
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 1,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        height: window.innerHeight
                    }}
                    onPress={() => setIsDrawerOpen(false)}
                />
            )}
        </Box>
    );
}